import HomePage from '@/pagesV2/home/index.vue';

/**
 * 新版首页路由配置
 */
const homeRoutes = [
  {
    path: '/home',
    component: HomePage,
    children: [
      {
        path: '',
        name: 'SchemePage',
        component: () => import('@/pagesV2/home/scheme/index.vue'),
        meta: {
          title: '方案'
        }
      },
      {
        path: 'product',
        name: 'ProductPage',
        component: () => import('@/pagesV2/home/product/index.vue'),
        meta: {
          title: '产品库'
        }
      }
    ]
  },
  {
    path: '/v2',
    redirect: '/home'
  },
  {
    path: '/v2/product',
    redirect: '/home/product'
  }
];

export default homeRoutes;
